import React from 'react';

const ChecklistIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <line x1="9" y1="11" x2="9" y2="17" />
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <polyline points="9 9 9 11" />
    <line x1="9" y1="7" x2="15" y2="7" />
    <line x1="9" y1="11" x2="15" y2="11" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

export default ChecklistIcon;
